document.addEventListener('DOMContentLoaded', function() {
  function CustomSlideoutDrawer() {
    // Trigger open slideout
    const triggers = document.querySelectorAll('[data-slideout-trigger]');
    triggers.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        e.preventDefault(); // ✅ stop default link/button action

        const slideoutId = this.getAttribute('data-slideout-trigger');
        const drawerContainer = document.querySelector(`[data-slideout-id="${slideoutId}"] .custom-slideout-drawer-container`);
        const drawer = document.querySelector(`[data-slideout-id="${slideoutId}"] .custom-slideout-drawer`);

        if (drawerContainer && drawer) {
          console.log('Opening drawer:', slideoutId);
          drawer.classList.toggle('open');
          drawerContainer.classList.toggle('open');
          drawerContainer.style.zIndex = '2147483650';
          document.body.classList.toggle('overflow-hidden');
        }
      });
    });

    // Close triggers
    const closeTriggers = document.querySelectorAll('[data-custom-slideout-drawer-close]');
    closeTriggers.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        e.preventDefault(); // ✅ stop default button behavior here too

        console.log('Close trigger clicked');
        const openDrawers = document.querySelectorAll('.custom-slideout-drawer.open');
        const openContainers = document.querySelectorAll('.custom-slideout-drawer-container.open');

        openDrawers.forEach(drawer => {
          drawer.classList.remove('open');
        });
        openContainers.forEach(container => {
          container.classList.remove('open');
          container.style.zIndex = ''; // Reset z-index
        });
        document.body.classList.remove('overflow-hidden');
      });
    });
  }

  CustomSlideoutDrawer();
});
